import { call, put, select, takeEvery, takeLeading } from "redux-saga/effects";
import { peApi } from "../../../api/tkb/peApi";
import { lopTinChiApi } from "../../../api/lop-tin-chi/lopTinChiApi";
import { xepTkbApi } from "../../../api/tkb/xepTkbApi";
import { IPhamViNhomLopUpdateRequest } from "../../../model/request/lop-tin-chi/IPhamViNhomLopUpdateRequest";
import { IPE_LopTinChiCreateRequest } from "../../../model/request/lop-tin-chi/IPE_LopTinChiCreateRequest";
import { IPE_LopTinChiCreateMultipleRequest } from "../../../model/request/lop-tin-chi/IPE_LopTinChiCreateMultipleRequest";
import { IPE_LopTinChiUpdateRequest } from "../../../model/request/lop-tin-chi/IPE_LopTinChiUpdateRequest";
import { ILopTinChiUpdateIdLopsRequest } from "../../../model/request/lop-tin-chi/ILopTinChiUpdateIdLopsRequest";
import { ISuKienSelectRequest } from "../../../model/request/tkb/ISuKienSelectRequest";
import { ISuKienUpdateRequest } from "../../../model/request/tkb/ISuKienUpdateRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { NotifyHelper } from "../../../helpers/toast";
import { ePEActionIds, IPEActionTypes } from "../../action-types/tkb/IPEActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.tkb.pe;
// Marker server gắn vào message khi trùng CÓ THỂ ghi đè (xem SuKienService.UpdatesXepTKBAsync).
const TRUNG_LICH_MARKER = "[TRUNG_LICH]";

export function* peSaga(): any {
  yield takeEvery(ePEActionIds.LOAD_LIST_START, loadListStart);
  yield takeLeading(ePEActionIds.CREATE_START, createStart);
  yield takeLeading(ePEActionIds.CREATE_MULTIPLE_START, createMultipleStart);
  yield takeLeading(ePEActionIds.UPDATE_START, updateStart);
  yield takeLeading(ePEActionIds.DELETE_START, deleteStart);
  yield takeLeading(ePEActionIds.DELETE_MULTIPLE_START, deleteMultipleStart);
  yield takeLeading(ePEActionIds.UPDATE_IDLOPS_START, updateIdLopsStart);
  yield takeLeading(ePEActionIds.UPDATE_PHAMVI_NHOMLOP_START, updatePhamViNhomLopStart);
  yield takeLeading(ePEActionIds.UPDATE_SUKIEN_START, updateSuKienStart);
}

// Nạp lại danh sách lớp + sự kiện theo filter hiện tại.
function* reloadList(): any {
  const filter: ISuKienSelectRequest = yield select((s: any) => s.tkb.pe.filter);
  if ((filter.ky_dang_ky ?? 0) > 0) {
    yield put(mainAction.LOAD_LIST_START({ ...filter, id_he: 0, id_mon: 0, khoa_hoc: 0, pl_giaidoan_idx: 0 }));
  }
}

function* loadListStart(action: IPEActionTypes): any {
  const res: IBaseRespone = yield call(xepTkbApi.SelectXepTKBLopTC, action.payload as ISuKienSelectRequest);
  if (res.is_success) {
    yield put(mainAction.LOAD_LIST_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_LIST_ERRR(res.message ?? "Có lỗi"));
  }
}

function* createStart(action: IPEActionTypes): any {
  const request = action.payload as IPE_LopTinChiCreateRequest;
  const res: IBaseRespone = yield call(peApi.CreatePE, request);
  if (res.is_success) {
    NotifyHelper.Success("Tạo lớp tín chỉ thành công");
    yield put(mainAction.CREATE_SUCCESS(res.data?.id_lop_tc ?? 0));
    yield put(mainAction.CLOSE_MODAL(undefined));
    yield* reloadList();
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi khi tạo lớp tín chỉ");
    yield put(mainAction.CREATE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* createMultipleStart(action: IPEActionTypes): any {
  const request = action.payload as IPE_LopTinChiCreateMultipleRequest;
  const res: IBaseRespone = yield call(peApi.CreatePEMultiple, request);
  if (res.is_success) {
    const count = Array.isArray(res.data) ? res.data.length : request.ten_lop_hps.length;
    NotifyHelper.Success(`Tạo ${count} lớp tín chỉ thành công`);
    yield put(mainAction.CREATE_SUCCESS(0));
    yield put(mainAction.CLOSE_MODAL(undefined));
    yield* reloadList();
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi khi tạo lớp tín chỉ");
    yield put(mainAction.CREATE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* updateStart(action: IPEActionTypes): any {
  const request = action.payload as IPE_LopTinChiUpdateRequest;
  const res: IBaseRespone = yield call(peApi.UpdatePE, request);
  if (res.is_success) {
    NotifyHelper.Success("Cập nhật lớp tín chỉ thành công");
    yield put(mainAction.UPDATE_SUCCESS(res.data?.id_lop_tc ?? 0));
    yield put(mainAction.CLOSE_MODAL(undefined));
    yield* reloadList();
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi khi cập nhật lớp tín chỉ");
    yield put(mainAction.UPDATE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteStart(action: IPEActionTypes): any {
  const id_lop_tc = action.payload as number;
  const res: IBaseRespone = yield call(peApi.DeletePE, id_lop_tc);
  if (res.is_success) {
    NotifyHelper.Success("Xóa lớp tín chỉ thành công");
    yield put(mainAction.DELETE_SUCCESS(id_lop_tc));
    yield* reloadList();
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi khi xóa lớp tín chỉ");
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteMultipleStart(action: IPEActionTypes): any {
  const ids = action.payload as number[];
  const res: IBaseRespone = yield call(peApi.DeleteMultiple, ids);
  if (res.is_success) {
    NotifyHelper.Success(`Xóa ${ids.length} lớp tín chỉ thành công`);
    yield put(mainAction.DELETE_SUCCESS(0));
    yield* reloadList();
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi khi xóa lớp tín chỉ");
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* updateIdLopsStart(action: IPEActionTypes): any {
  const request = action.payload as ILopTinChiUpdateIdLopsRequest;
  const res: IBaseRespone = yield call(peApi.UpdateIdLops, request);
  if (res.is_success) {
    NotifyHelper.Success("Cập nhật phạm vi lớp thành công");
    yield put(mainAction.UPDATE_IDLOPS_SUCCESS(0));
    yield* reloadList();
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi khi cập nhật phạm vi lớp");
    yield put(mainAction.UPDATE_IDLOPS_ERRR(res.message ?? "Có lỗi"));
  }
}

function* updatePhamViNhomLopStart(action: IPEActionTypes): any {
  const request = action.payload as IPhamViNhomLopUpdateRequest;
  const res: IBaseRespone = yield call(lopTinChiApi.UpdatePhamViNhomLopDelta, request);
  if (res.is_success) {
    NotifyHelper.Success("Cập nhật phạm vi nhóm lớp thành công");
    yield put(mainAction.UPDATE_PHAMVI_NHOMLOP_SUCCESS(0));
    yield* reloadList();
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi khi cập nhật phạm vi nhóm lớp");
    yield put(mainAction.UPDATE_PHAMVI_NHOMLOP_ERRR(res.message ?? "Có lỗi"));
  }
}

function* updateSuKienStart(action: IPEActionTypes): any {
  const request = action.payload as ISuKienUpdateRequest;
  const res: IBaseRespone = yield call(xepTkbApi.UpdateTKB, request);
  if (res.is_success) {
    yield put(mainAction.UPDATE_SUKIEN_SUCCESS(res.data));
  } else if ((res.message ?? "").startsWith(TRUNG_LICH_MARKER)) {
    const message = (res.message ?? "").substring(TRUNG_LICH_MARKER.length).trim();
    yield put(mainAction.UPDATE_SUKIEN_TRUNG({ request, message }));
  } else {
    NotifyHelper.Error(res.message ?? "Có lỗi khi xếp lịch");
    yield put(mainAction.UPDATE_SUKIEN_ERRR(res.message ?? "Có lỗi"));
  }
}
